export default __webpack_public_path__ + "static/media/francheville30.03a6ce8a.jpg";